import Column from '@/components/nav/dropdown/column';
import Content from '@/components/nav/dropdown/content';
import ContentCard from '@/components/nav/dropdown/content-card';
import Link from '@/components/nav/dropdown/link';
import PersonaLink from '@/components/nav/dropdown/persona-link';
import Dropdown from '@/components/nav/dropdown';
import {
  Star,
  Globe,
  Building,
  Security,
} from '@/components/nav/content/icons';
import { Businesses, Creators, Engineering } from '@/components/icons/personas';
import Label from '@/components/nav/dropdown/label';

export function Product({ isDesktop }: { isDesktop: boolean }) {
  return (
    <Dropdown>
      <div className="flex-shrink-0 w-full lg:max-w-[315px] max-w-full flex flex-col justify-between lg:border-r border-catskill-white border-b lg:border-b-0 mb-5 lg:mb-0 pb-5 lg:pb-0">
        <div className="px-2 lg:pl-9 lg:pr-6 lg:py-6">
          <Label className="pb-5 lg:pb-7">GraphCMS for</Label>
          <div className="grid grid-cols-1 space-y-4 lg:space-y-0 lg:-mx-3">
            <PersonaLink
              href="/for-engineering"
              title="Engineering Teams"
              subTitle="Build. On your terms"
              icon={Engineering}
              variant="purple"
            />
            <PersonaLink
              href="/for-content-creators"
              title="Content Creators"
              subTitle="Deliver perfect experiences"
              icon={Creators}
              variant="rose"
            />
            <PersonaLink
              href="/for-businesses"
              title="Businesses"
              subTitle="Scale in all directions"
              icon={Businesses}
              variant="blue"
            />
          </div>
        </div>
      </div>
      <Column label="Platform" className="lg:min-w-[245px]">
        <Link href="/product" title="Product" icon={Star} />
        <Link href="/partners" title="Partners" icon={Globe} />
        <Link
          href="/enterprise-headless-cms"
          title="Enterprise"
          icon={Building}
        />
        <Link
          href="/security-and-compliance"
          title="Security & Compliance"
          icon={Security}
        />
      </Column>
      {isDesktop && (
        <Content>
          <ContentCard
            href="https://app.graphcms.com/signup"
            label="Get started"
            image={{
              src: `/images/nav/signup.svg`,
              blurDataURL: `data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAQAAAADCAIAAAA7ljmRAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAMklEQVQImQEnANj/AAAAWGhhn3Fqpj47hgAAD2n9/f/////HxNwAAABdhX+wnZe/bGWhRpgSjBAxC0kAAAAASUVORK5CYII=`,
            }}
            title="Create a free-forever developer account"
          />
          <ContentCard
            href="/academy/headless-cms"
            label="Basics"
            image={{
              src: `/images/nav/headless-cms.svg`,
              blurDataURL: `data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAQAAAADCAIAAAA7ljmRAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAMklEQVQImQEnANj/AKc2ZNyUrd+atGUAHwDbk6r/+v/p3OnRgJ0AUAAA9sfb25Oqs01yrc8WLomBPwgAAAAASUVORK5CYII=`,
            }}
            title="What is a Headless CMS"
          />
        </Content>
      )}
    </Dropdown>
  );
}
